import type { Session, User } from '../../shared/api'
import { api } from '../../shared/api'

import { useAuthStore } from './hooks'

export async function login(email: string, password: string) {
  const session = await api<Session>('/auth/login', {
    method: 'POST',
    body: { email, password },
  })

  useAuthStore.getState().setSession(session)

  return session
}

export async function logout() {
  const csrf = document.cookie
    .split('; ')
    .find((c) => c.startsWith('cms_csrf='))
    ?.slice(9)

  await fetch('/api/v1/auth/logout', {
    method: 'POST',
    credentials: 'same-origin',
    headers: csrf ? { 'x-csrf-token': decodeURIComponent(csrf) } : {},
  }).catch(() => undefined)
  useAuthStore.getState().clear()
}

export const updateProfile = (displayName: string) =>
  api<User>('/auth/me', { method: 'PATCH', body: { displayName } })
export const changePassword = (currentPassword: string, newPassword: string) =>
  api<void>('/auth/change-password', {
    method: 'POST',
    body: { currentPassword, newPassword },
  })
